import { useEffect } from "react";

const BASE = "https://buukd.co";

/**
 * Set page title, meta description, and canonical URL for SEO.
 * Use on every public page you want indexed so each URL has unique meta.
 */
export function usePageMeta({
  title,
  description,
  path = "/",
}: {
  title: string;
  description: string;
  path?: string;
}) {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", path.startsWith("http") ? path : `${BASE}${path === "/" ? "" : path}`);
  }, [title, description, path]);
}
